export enum StorePosStatusType {
  OK = 'OK',
  LATER = 'LATER',
}

export type PointOfSale = {
  name: string;
  id?: string | null;
};

export type CreatePosBody = {
  status: StorePosStatusType;
  pointOfSale?: PointOfSale;
};

export type PosContextProps = {
  isPosOpen: boolean;
  isSubmitting: boolean;
  handleAnswerLater: () => void;
  handleAnswerOk: (pointOfSale: AutocompletePointOfSaleType | undefined) => void;
  onClose: () => void;
};

export type AutocompletePointOfSaleType = {
  label?: string;
} & PointOfSale;
